import { useEffect, useState, type FormEvent } from 'react';

type Role = 'admin' | 'maintainer';
interface User { email: string; role: Role }

export function Settings() {
  const [users, setUsers] = useState<User[]>([]);
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<Role>('maintainer');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(false);
  const selected = users.find((user) => user.email === email.trim().toLowerCase());

  useEffect(() => {
    let active = true;
    fetch('/api/users').then(async (response) => {
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Не удалось загрузить пользователей.');
      if (active) setUsers(data.users);
    }).catch((cause) => { if (active) setError(cause instanceof Error ? cause.message : 'Не удалось загрузить пользователей.'); });
    return () => { active = false; };
  }, []);

  const choose = (user: User) => {
    setEmail(user.email); setRole(user.role); setPassword(''); setConfirm(''); setError(''); setNotice('');
  };

  const submit = async (event: FormEvent) => {
    event.preventDefault(); setError(''); setNotice('');
    if (password !== confirm) { setError('Пароли не совпадают.'); return; }
    if (!selected && password.length < 12) { setError('Для нового пользователя нужен пароль от 12 символов.'); return; }
    setBusy(true);
    try {
      const response = await fetch('/api/users', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, role, ...(password ? { password } : {}) }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Не удалось сохранить пользователя.');
      setUsers((current) => [...current.filter((user) => user.email !== data.user.email), data.user].sort((a, b) => a.email.localeCompare(b.email)));
      setEmail(data.user.email); setPassword(''); setConfirm('');
      setNotice(data.created ? 'Пользователь добавлен. Передайте ему email и пароль безопасным способом.' : 'Изменения сохранены. Если пароль был изменён, прежние сеансы завершены.');
    } catch (cause) { setError(cause instanceof Error ? cause.message : 'Не удалось сохранить пользователя.'); }
    finally { setBusy(false); }
  };

  return <main className="studio settings-page">
    <div className="studio-heading"><div><div className="eyebrow">АДМИНИСТРИРОВАНИЕ</div><h1>Пользователи и доступ</h1>
      <p>Пригласите Артёма в редактор или обновите доступ существующего пользователя.</p></div></div>
    <div className="settings-grid">
      <section className="studio-main"><div className="section-header"><h2>Команда</h2><p>Пароли здесь не отображаются.</p></div>
        <div className="settings-users">{users.map((user) => <button key={user.email} type="button" className={selected?.email === user.email ? 'selected' : ''} onClick={() => choose(user)}>
          <span className="settings-avatar">{user.email.slice(0, 1).toUpperCase()}</span><span><strong>{user.email}</strong><small>{user.role === 'admin' ? 'Администратор · полный доступ' : 'Редактор · только сценарий и экспорт'}</small></span><span className="settings-chevron">→</span>
        </button>)}</div>
        <button type="button" className="secondary-button settings-add" onClick={() => { setEmail(''); setRole('maintainer'); setPassword(''); setConfirm(''); setError(''); setNotice(''); }}>+ Добавить пользователя</button>
      </section>
      <form className="studio-main settings-form" onSubmit={submit}><div className="section-header"><h2>{selected ? 'Изменить доступ' : 'Новый пользователь'}</h2>
        <p>{selected ? 'Можно поменять роль и задать новый пароль.' : 'Задайте рабочий email, пароль и уровень доступа.'}</p></div>
        <label>Email<input type="email" required autoComplete="off" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="artem@example.com" /></label>
        <label>Роль<select value={role} onChange={(event) => setRole(event.target.value as Role)}><option value="maintainer">Редактор — только сценарий и экспорт</option><option value="admin">Администратор — весь SimTool</option></select></label>
        <div className="settings-role-note">Для Артёма выберите «Редактор». Он увидит комнаты, лут и предметы и сможет сохранить сценарий и экспортировать значения.</div>
        <label>{selected ? 'Новый пароль (необязательно)' : 'Пароль'}<input type="password" autoComplete="new-password" minLength={12} required={!selected} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Минимум 12 символов" /></label>
        <label>Повторите пароль<input type="password" autoComplete="new-password" required={Boolean(password)} value={confirm} onChange={(event) => setConfirm(event.target.value)} /></label>
        {error && <div className="studio-notice error" role="alert">{error}</div>}
        {notice && <div className="studio-notice" role="status">{notice}</div>}
        <button className="primary-button" disabled={busy}>{busy ? 'Сохраняю…' : selected ? 'Сохранить изменения' : 'Добавить пользователя'}</button>
      </form>
    </div>
  </main>;
}
